import type { ValidationStatus } from '@fiverr-private/store_builder_types';

interface StepValidationState {
    validations: Record<string, () => ValidationStatus>;
    validationsAfterContinue: Record<string, () => Promise<ValidationStatus>>;
}

export type StepValidationAction =
    | { type: 'REGISTER_VALIDATION'; stepId: string; validationStatusFn: () => ValidationStatus }
    | {
          type: 'REGISTER_VALIDATION_AFTER_CONTINUE';
          stepId: string;
          validationStatusFn: () => Promise<ValidationStatus>;
      }
    | { type: 'UNREGISTER_VALIDATION'; stepId: string }
    | { type: 'UNREGISTER_VALIDATION_AFTER_CONTINUE'; stepId: string }
    | { type: 'MARK_STEP_COMPLETED'; stepId: string };

export const stepValidationReducer = (
    state: StepValidationState,
    action: StepValidationAction
): StepValidationState => {
    switch (action.type) {
        case 'REGISTER_VALIDATION':
            return {
                ...state,
                validations: {
                    ...state.validations,
                    [action.stepId]: action.validationStatusFn,
                },
            };

        case 'REGISTER_VALIDATION_AFTER_CONTINUE':
            return {
                ...state,
                validationsAfterContinue: {
                    ...state.validationsAfterContinue,
                    [action.stepId]: action.validationStatusFn,
                },
            };

        case 'UNREGISTER_VALIDATION':
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.stepId]: _, ...remainingValidations } = state.validations;
            return {
                ...state,
                validations: remainingValidations,
            };

        case 'UNREGISTER_VALIDATION_AFTER_CONTINUE':
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.stepId]: __, ...remainingValidationsAfterContinue } = state.validationsAfterContinue;
            return {
                ...state,
                validationsAfterContinue: remainingValidationsAfterContinue,
            };

        case 'MARK_STEP_COMPLETED':
            return {
                ...state,
                validations: {
                    ...state.validations,
                    [action.stepId]: () => 'valid',
                },
            };

        default:
            return state;
    }
};
